<template>
  <div :class="['form-autocomplete-add-wrapper',id=='troskovnik-vps'?'troskovnik-currency':'']">
    <div class="form-input-wrapper form-input-currency">
        <label class="form-label" for="form-input-element">
            <span>{{ label }}</span>
        </label>
        <input
        id="form-input-element"
        :class="['form-input',invalid ? 'invalid':'']"
        v-model="displayVal"
        @blur="isInputActive = false" 
        @focus="isInputActive = true"
        />
    </div>
    <div class="input-currency-element">
      <select
        name="drop-element"
        id="drop-element"
        class="input-quick-select-dropdown input-select-main"
        v-model="drop_value"
      >
        <option v-for="(valuta, k) in dropImport" :key="k" :value="valuta.uid">
          {{ valuta.short_name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
export default {
  props: ["baseInput", "baseDropDown", "dropImport", "label", "invalid", "id","is_troskovnik"],
  data() {
      return {
          input_value: 0,
          drop_value: 1,
          croatianNumberFormat:Intl.NumberFormat('hr-HR'),
          isInputActive: false
      }
  },
  components:{
      "form-input": formInput,
  },
  // watch:{
  //   // "$store.state.currency_data":{
  //   //   handler:function () {
  //   //     if (this.is_troskovnik) {
  //   //       this.input_value = this.$store.state.currency_data.input_value;
  //   //       this.drop_value = this.$store.state.currency_data.drop_value;
  //   //     }
  //   //   },
  //   //   deep:true
  //   // }
  // },
  computed:{
    displayVal:{
      get: function() {
          if (this.isInputActive) {
              // Cursor is inside the input field. unformat display value for user
              return this.input_value.toString()
          } else {
              // User is not modifying now. Format display value for user interface
              if (this.input_value != '' && this.input_value != null) {
                let temp_val = this.input_value.toFixed(2).toString().replaceAll('.',',');
                return temp_val.replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
                // return this.croatianNumberFormat.format(this.input_value);
              }
              else{
                return ''
              }
          }
      },
      set: function(modifiedValue) {
          // Recalculate value after ignoring "$" and "," in user input
          modifiedValue = modifiedValue.replaceAll(',','.');
          this.input_value = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
          // this.$store.state.currency_data.input_value = this.input_value;
          // Ensure that it is not NaN
          if (isNaN(this.input_value)) {
              this.input_value = 0;
              // this.$store.state.currency_data.input_value = this.input_value;
          }
      }
    }
  },
  methods: {
    saveValue(e){
      console.log(e)
    },
    setValue() {
        if (!isNaN(this.baseInput)) {
          this.input_value = this.baseInput;
          this.drop_value = parseInt(this.baseDropDown)
        }
      },
  },
  mounted() {
    let vm = this;
    vm.$nextTick(function () {
      this.inputType = vm.id;
      setTimeout(this.setValue, 500);
    });
  },
  
};
</script>